import React from 'react';
import cn from 'classnames';
import { Visibility, Align } from '../../../../../../../types/common-types';
import './style.scss';

interface ImageProps {
  id?: string;
  value: string;
  visibility?: Visibility;
  align?: Align;
  style?: object;
  extra?: { alt?: string };
}

const Image: React.FC<ImageProps> = ({
  id,
  value,
  visibility = Visibility.Visible,
  style,
  align,
  extra = { alt: '' },
}) => {
  return (
    <div
      id={id}
      data-cy="image"
      className="image"
      styleName={cn('image', {
        disabled: visibility === Visibility.Disabled,
        hidden: visibility === Visibility.Hidden,
        left: align === Align.Left,
        center: align === Align.Center,
        right: align === Align.Right,
      })}
    >
      <img alt={extra.alt} src={value} style={style} />
    </div>
  );
};

export default Image;
